import styled from '~/design/styled'

const maxWidth = 1000

export const CenteredContentContainer = styled.div({
  maxWidth,
  width: `${(maxWidth / 1440) * 100}%`,
  margin: '0 auto',
})
